import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import createResponsive from '../../utils/createResponsive.js';
import warnDeprecation from '../../utils/warnDeprecation.js';
import { jsx } from '@emotion/react';
import { Button, BUTTON_SIZES, sizes } from '../Button/Button.js';
import '../../utils/warn.js';
import 'focus-visible';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';

const variants = {
  tertiary: {
    color: "foreground.strong",
    ":hover": {
      color: "foreground.strong"
    },
    ":active": {
      color: "foreground.strong"
    }
  },
  primary: {},
  secondary: {},
  inverse: {
    borderColor: "transparent"
  },
  utility: {}
};
const getPadding = createResponsive(size => sizes[size]);

// IconButton inherits minBlockSize from Button, setting minInlineSize here
// to ensure they always render as perfect squares.
const minInlineSize = {
  sm: "2.25rem",
  md: "2.75rem",
  lg: "3.25rem"
};
const getMinInlineSize = createResponsive(size => minInlineSize[size]);

/**
 * @see https://experience.indeed.design/components/ids/icon-button
 *
 * @deprecated The `IconButton` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const IconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    sx = {},
    ...props
  } = _ref;
  warnDeprecation(deprecationWarning);
  const {
    size = "md",
    variant = "primary"
  } = props;
  return jsx(Button, _extends({
    ref: ref,
    sx: {
      ...variants[variant],
      paddingInlineStart: getPadding(size),
      paddingInlineEnd: getPadding(size),
      minInlineSize: getMinInlineSize(size),
      ...sx
    }
  }, props), children);
});
const ICON_BUTTON_VARIANTS = ["primary", "secondary", "tertiary", "inverse", "utility"];
const ICON_BUTTON_SIZES = BUTTON_SIZES;
IconButton.displayName = "IconButton";

// Remove in IFL-1750
const deprecationWarning = `[IconButton] The IconButton component will be removed in IFL 7. See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide`;

export { ICON_BUTTON_SIZES, ICON_BUTTON_VARIANTS, IconButton };
